import {ActionReducerMap, MetaReducer} from "@ngrx/store";
import {tenantCabinetReducers, TenantCabinetState, tenantFeatureKey} from './sections/tenant-cabinet/tenant-cabinet.reducers';
import {messengerFeatureKey, messengerReducer, MessengerState} from '@messenger/_store/messenger.reducer';
import {organizationCabinetReducers, OrganizationCabinetState, organizationFeatureKey} from './sections/organization-cabinet/organization-cabinet.reducers';
import {coreReducer, CoreState, coreStateFeatureKey} from '@common/store/reducers/core.reducer';
import {currentUserFeatureKey, currentUserReducer, CurrentUserState} from '@common/store/reducers/user.reducer';
import {supportFeatureKey, supportReducer, SupportState} from './support/_store/support.reducer';

export interface DahState {
    [coreStateFeatureKey]: CoreState,
    [currentUserFeatureKey]: CurrentUserState,
    [messengerFeatureKey]: MessengerState,
    [supportFeatureKey]: SupportState,

    [organizationFeatureKey]: OrganizationCabinetState,
    [tenantFeatureKey]: TenantCabinetState,
}

export const reducers: ActionReducerMap<DahState> = {
    [coreStateFeatureKey]: coreReducer,
    [currentUserFeatureKey]: currentUserReducer,
    [messengerFeatureKey]: messengerReducer,
    [supportFeatureKey]: supportReducer,

    [organizationFeatureKey]: organizationCabinetReducers,
    [tenantFeatureKey]: tenantCabinetReducers,
};

export const metaReducers: MetaReducer<DahState>[] = [];
